import React, { lazy, PropsWithChildren, Suspense, useMemo } from "react";
import { isCorpTenant } from "@capone/common";
import { config } from "../../../api/config";

export const BaseProviders: React.FC<
  PropsWithChildren<{ showCoreHomepage?: boolean }>
> = ({ children }) => {
  const PortalComponent = useMemo(() => {
    if (isCorpTenant(config.TENANT)) {
      return lazy(() => import("../CorporatePortal"));
    }
    return lazy(() => import("../Portal"));
  }, []);

  return (
    <Suspense fallback="loading">
      <PortalComponent>{children}</PortalComponent>
    </Suspense>
  );
};
